import type { ComponentType } from 'react';
import { Platform } from 'react-native';
import { Redirect } from 'expo-router';

/**
 * The cancel-journey / lapse routes are native screens. On web the same steps
 * live in dialogs (CancelPlanDialog.web, the web lapse coordinator), so a
 * direct visit to one of these URLs goes to Plan & billing instead of
 * rendering native chrome. `Platform.OS` never changes, so hook order is safe.
 */
export function nativeJourneyRoute(Screen: ComponentType, webFallback = '/settings/billing') {
  return function NativeJourneyRoute() {
    if (Platform.OS === 'web') return <Redirect href={webFallback as never} />;
    return <Screen />;
  };
}
